import Head from 'next/head'
import React from 'react'
import { SINGLE_ROUTES } from '~/lib/constants'

import LoadingPage from '~/components/Abstracts/LoadingPage'

import useAuthentication from '~/hooks/account/useAuthentication'

export default function withAuthentication(WrappedComponent) {
  const HOC = (pageProps) => {
    const { isInitialLoading, data: customer } = useAuthentication(
      SINGLE_ROUTES.login.href,
      null,
    )

    return isInitialLoading || !customer ? (
      <LoadingPage />
    ) : (
      <>
        <Head>
          <meta key="robots" name="robots" content="noindex,nofollow" />
        </Head>
        <WrappedComponent {...pageProps} />
      </>
    )
  }

  return HOC
}
